import { createFileRoute } from '@tanstack/react-router';

import { CoachLayout } from '~/features/coach/coach-page';

/** Every Coach page: the threads panel beside the conversation (boards 11-coach-home, 11-coach-thread). */
export const Route = createFileRoute('/_app/coach')({ component: CoachLayout });
